













































































































import { EmployeeFormSubmissionStateEnum } from '@/models';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { IEmployeeFormSubmissionFetchParams } from '@/services';
import { mapGetters } from 'vuex';

export default mixins(auth).extend({
  name: 'VacationCarryOverRequestSerachFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IEmployeeFormSubmissionFetchParams,

      stateList: [
        {
          value: EmployeeFormSubmissionStateEnum.Draft,
          display_name: 'Draft'
        },

        {
          value: EmployeeFormSubmissionStateEnum.InReview,
          display_name: 'Submitted'
        },

        {
          value: EmployeeFormSubmissionStateEnum.InProgress,
          display_name: 'In Progress'
        },

        {
          value: EmployeeFormSubmissionStateEnum.Completed,
          display_name: 'Completed'
        },

        {
          value: EmployeeFormSubmissionStateEnum.Cancelled,
          display_name: 'Cancelled'
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      FormTemplates: 'formTemplate/getFormTemplates'
    }),

    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IEmployeeFormSubmissionFetchParams) {
      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      if (params.form != null && !isNaN(params.form)) {
        this.filterParams.form = Number(params.form);
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
